var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAboutTitleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.1927 6.02969L21.9299 0.801306C20.8545 -0.267102 19.1155 -0.267102 18.0401 0.801306L12.7773 6.02969C11.7018 7.0981 11.7018 8.82573 12.7773 9.89414L18.0401 15.1225C19.1155 16.1909 20.8545 16.1909 21.9299 15.1225L27.1927 9.89414C28.2681 8.82573 28.2681 7.0981 27.1927 6.02969Z",
    fill: "#4BB7FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3402 17.037C14.1751 17.037 16.4733 14.7539 16.4733 11.9375C16.4733 9.12105 14.1751 6.83789 11.3402 6.83789C8.50521 6.83789 6.20703 9.12105 6.20703 11.9375C6.20703 14.7539 8.50521 17.037 11.3402 17.037Z",
    fill: "url(#paint0_linear_992_182)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.341 28.9994C14.9525 28.9994 18.358 28.5448 21.367 27.7416C22.4119 27.4612 22.9611 26.3208 22.5225 25.3358C20.6271 21.0697 16.333 18.0918 11.3372 18.0918C6.34137 18.0918 2.04724 21.0697 0.151881 25.3358C-0.286683 26.3208 0.262491 27.4612 1.31123 27.7416C4.32398 28.5448 7.72953 28.9994 11.341 28.9994Z",
    fill: "url(#paint1_linear_992_182)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.834 7.95898H23.1493",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9902 4.82422V11.0983",
    stroke: "white",
    strokeWidth: 3,
    strokeMiterlimit: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_992_182",
    x1: 13.9064,
    y1: 16.3559,
    x2: 8.82178,
    y2: 7.49121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4085FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BB7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_992_182",
    x1: 14.6416,
    y1: 31.6689,
    x2: 7.15493,
    y2: 18.6163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4085FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4BB7FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutTitleIcon);
export default __webpack_public_path__ + "static/media/about_title_icon.f903dee5bde5a2d80a2a2a0ac29c2a8c.svg";
export { ForwardRef as ReactComponent };